import React from 'react'

import theme from 'app/match/applicationReportPDF/assets/theme'
import { standardUTCFormat } from 'app/sm/helpers'
import DateDropDown from 'app/sm/properties/components/excluded_times/partials/date_dropdown'
import * as dateTimeHelpers from 'app/utils/datetime/helpers'

export const FilterSingleDate = ({ filterConfig, onChange, ...props }) => {
  const {
    filterId,
    filterValues = {},
    format = standardUTCFormat,
  } = filterConfig

  const date = filterValues[filterId]

  return (
    <DateDropDown
      date={date}
      format={format}
      {...(props.dropDownWidth && { width: props.dropDownWidth })}
      {...(props.dropDownHeight
        ? { height: props.dropDownHeight }
        : { height: theme.height[18] + 'px' })}
      lineHeight={0.9}
      onDateChangedHandler={(date) => {
        onChange(date)
      }}
      closeOnChange
      labelRenderer={(date) =>
        date ? `${dateTimeHelpers.formattedUTCDisplayDate(date)}` : 'Date'
      }
    />
  )
}
